import React from "react";

export default function MSAccess_UCase() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_UCase</h1>
      <p>This is the MSAccess_UCase component generated from the SQL JSON.</p>
    </div>
  );
}
